import axios from 'axios'
import { ElLoading, ElMessageBox } from 'element-plus'
import router from '../router'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.3.254:5000/', // 正式
  baseURL: 'http://192.168.3.222:5000/', // 测试
  timeout: 30000
})
let loading

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 请求开始时显示加载状态
    loading = ElLoading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    // 将加载实例保存到请求配置中
    config.loading = loading

    return config
  },
  (error) => {
    // 请求错误处理
    loading.close()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 请求成功处理
    loading.close()
    return response.data
  },
  (error) => {
    // 请求失败处理
    console.log(error, 'error>>>>>')
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.message === 'Token has expired') {
          sessionStorage.removeItem('token')
          router.push('/')
        }
      } else {
        if (error.response.data.message) {
          ElMessageBox.alert(error.response.data.message, '', {
            confirmButtonText: 'OK',
            callback: () => {
     
            }
          })
        } else {
          let val = ''
          if (error.response.data.error) {
            val = error.response.data.error
          } else {
            val = '服务器内部错误，请联系系统开发人员'
          }
          ElMessageBox.alert(val, '', {
            confirmButtonText: 'OK',
            callback: () => {
            }
          })
        }
      }
    } else {
      ElMessageBox.alert('操作失败', '', {
        confirmButtonText: 'OK',
        callback: () => {
          // router.push('/')
        }
      })
    }

    loading.close()
    return Promise.reject(error)
  }
)

export default service
